import { useFormApi } from '@data-driven-forms/react-form-renderer';
import { useTheme } from '@emotion/react';
import { ChildrenWidget } from 'lib-node-amb-renderer';

import { useActiveFieldStore } from '~/common/componentMapper/QuestionExtraction/activeFieldStore';
import SimpleGrid from '~/common/components/Grids/Grid/SimpleGrid';

import { inputComponentNames } from '../QuestionExtraction/constants';

export class ActiveFieldBackgroundClass extends ChildrenWidget {
  constructor(props) {
    super(props);
  }
}

type ActiveFieldBackgroundProps = {
  fields?: any[];
  columns?: number;
  rowSpacing?: string;
  columnSpacing?: string;
  sx?: any;
};

const ActiveFieldBackground = ({
  fields = [],
  columns,
  rowSpacing = '10px',
  columnSpacing = '10px',
  sx,
}: Readonly<ActiveFieldBackgroundProps>) => {
  const { renderForm } = useFormApi();

  const theme = useTheme();
  const { activeField } = useActiveFieldStore();

  const fieldsToMakeActive = fields?.map(({ name, component }) => {
    if (!!name && inputComponentNames.includes(component)) return name;
  });

  const isActive = fieldsToMakeActive.includes(activeField);

  const styles = {
    backgroundColor: isActive ? theme.colors?.gray[200] : 'none',
    padding: sx?.padding ?? '1rem 0',
    ...sx,
  };
  return (
    <SimpleGrid
      columnGap={columnSpacing}
      rowGap={rowSpacing}
      gridTemplateColumns={`repeat(${columns}, 1fr)`}
      sx={styles}
    >
      {renderForm(fields)}
    </SimpleGrid>
  );
};

export default ActiveFieldBackground;
